import { useEffect } from 'react';

import { useAppDispatch } from '@/data/store/utils/redux';
import { initSocket, setConnectionStatus } from '@/data/store/actions/sockets';
import { auth } from '@/data/config/firebase-config';

export const useSocketManagement = () => {
  const dispatch = useAppDispatch();

  // Initialize sockets
  useEffect(() => {
    dispatch(setConnectionStatus(false));
    dispatch(initSocket());
  }, [dispatch, auth.currentUser]);
};
